import React, { useEffect } from "react";
import { useHistory } from "react-router-dom";
import moment from 'moment';
import 'moment/locale/zh-tw';

import { connect } from 'react-redux';
import { getPost } from '../actions/social';

import { Row, Col, Skeleton } from 'antd';
import { Helmet } from 'react-helmet';

import unlikeImg from '../assets/images/icon-post-interact-unlike-24@3x.png';
import commentImg from '../assets/images/icon-post-interact-comment-24@3x.png';
import shareImg from '../assets/images/icon-cell-social-icon-share-disable@3x.png';
import avatarImg from '../assets/images/image_userhead_36@3x.png';

// Swiper
import { Swiper, SwiperSlide } from 'swiper/react';
import "swiper/swiper.min.css";

export function PostContent(props) {
    let history = useHistory();
    let pid = props.pid;
    const popUpState = props.popUpState;
    const setPopUpState = props.setPopUpState;
    const defaultName = 'FitGames用戶';

    const { postData } = props;

    useEffect(() => {
        props.getPost(pid);
    }, [pid]);

    useEffect(() => {
        if (postData.pageNotFound) {
            history.push('/pageNotFound');
        }
    }, [postData.pageNotFound]);

    const createMarkup = () => {
        let str = String(postData.body);
        let re = /(\r\n)|(\n)/g;
        let reLink = /(https?:\/\/[\w\-/.?=&#]+)/g; 

        let newStr = str.replace(re, "<br>").replace(reLink, "<a href='$1'>$1</a>");
        return { __html: newStr };        
    }

    const getDate = () => {
        moment.locale('zh-tw')
        let dateLocal = moment(postData.lastUpdate * 1000).format('LL');

        return dateLocal;
    }

    const handleFooter = (props) => {
        setPopUpState({
            isOpen: !popUpState.isOpen,
            popUpType: props,
        })
    }

    const getImage = () => {
        var imgUrl = 'https://user-images.strikinglycdn.com/res/hrscywv4p/image/upload/c_limit,fl_lossy,h_9000,w_1200,f_auto,q_auto/2962622/747616_879440.png';
        postData.imgUrls.some(url => {
            if (!url.includes('.gif')) {
                imgUrl = url;
                return true;
            }
        })
        return imgUrl;
    }

    return (
        <div className="content-box">
            <Helmet>
                <meta charSet="utf-8" />
                <title>{postData.title} - FitGames</title>
                <meta name='description' content={postData.body} />
                <meta property='og:title' content={`${postData.title} - FitGames`} />
                <meta property='og:image' content={getImage()} />
                <meta property='og:description' content={postData.body} />
            </Helmet>
            <Skeleton active avatar paragraph={{ rows: 16 }} loading={postData.isLoading}>
                <div className="content-sender-row">
                    <div className="content-sender-icon-box">
                        <img src={postData.senderIcon || avatarImg} className="content-sender-icon" alt="sender icon" />
                    </div>

                    <div className="content-single-row">
                        <Row>
                            <Col span={24}>
                                <font className="content-sender-text">{postData.sender || defaultName}</font>
                                <br />
                                <font className="content-time-text">{getDate()}</font>
                            </Col>
                        </Row>
                    </div>
                </div>

                <div className="content-single-row">
                    <div dangerouslySetInnerHTML={createMarkup()} className="content-text" />
                </div>

                <div className="content-sharing-img-box">
                    <Swiper
                        spaceBetween={12}
                        width={218}
                        freeMode={true}
                        // loop={true}
                        breakpoints={{
                            "768": {
                                "width": 350,
                                "spaceBetween": 19
                            },
                        }}
                    >

                        {postData.imgUrls.map((image, index) => (
                            <SwiperSlide key={index}>
                                <img src={image} className="content-sharing-img" alt="postphoto" />
                            </SwiperSlide>
                        ))}
                    </Swiper>
                </div>

                <div className="content-footer-box">
                    <div className="content-single-row content-footer-align">
                        <button className="content-footer-btn" onClick={() => handleFooter("like")}>
                            <img src={unlikeImg} className="content-footer-btn-img" alt="unlike" />
                            <font className="content-footer-text">{postData.likeCount}</font>
                        </button>
                    </div>
                    <div className="content-single-row content-footer-align">
                        <button className="content-footer-btn" onClick={() => handleFooter("comment")}>
                            <img src={commentImg} className="content-footer-btn-img" alt="comment" />
                            <font className="content-footer-text">{postData.commentCount}</font>
                        </button>
                    </div>
                    <div className="content-single-row content-footer-align">
                        <button className="content-footer-btn">
                            <img src={shareImg} className="content-footer-btn-img" alt="share" />
                        </button>
                    </div>
                </div>
            </Skeleton>
        </div>
    );
}


const mapStateToProps = state => ({
    postData: state.social,
});

const mapDispatchToProps = {
    getPost
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(PostContent);